
import DescriptionSection from "../components/DescriptionSection";
// import FeatureSection from "../components/FeatureSection";
import FooterSection from "../components/FooterSection";
// import GetStartedSection from "../components/GetStartedSection";
import HeroSection from "../components/HeroSection";
import NavbarComponent from "../components/NavbarComponent";
// import TeamSection from "../components/TeamSection";
import TestimonySection from "../components/TestimonySection";
import BACKGROUND_IMAGE from "../assets/herobg.png"
// import PricingSection from "../components/PricingSection";
import HowItWorksSection from "../components/HowItWorksSection";
import IconSection from "../components/IconSection";
import AllFeaturesSection from "../components/AllFeaturesSection";
import UKBusinessesSection from "../components/UKBusinessSection";
import FAQSection from "../components/FaqSection";

const Home = () => {
  return (
    <>
      <div
        style={{
          backgroundImage: `url(${BACKGROUND_IMAGE})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <NavbarComponent />
        <HeroSection />
      </div>

      <HowItWorksSection />
      <IconSection />
      <AllFeaturesSection />
      <UKBusinessesSection />

      
      <DescriptionSection />
      <TestimonySection />
      <FAQSection/>
      {/* <GetStartedSection /> */}
      <FooterSection />

    </>
  );
};

export default Home;
